import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  public currentUser: BehaviorSubject<any> = new BehaviorSubject<any>('');

  constructor(private http: HttpClient, private router: Router, private authService: AuthService) { }

  //Hospital Info API's
  getAllProviderType() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/getAllProviderType', httpOptions);
  }

  getStates() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/getStates', httpOptions);
  }

  getCitiesByState(stateId: any) {
    const param = new HttpParams().set('id', stateId);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/getCityByState', httpOptions);
  }

  //Get Provider & Hopsital Details
  getProviderProfile() {
    const param = new HttpParams().set('providerBranchId', this.authService.currentUserValue.providerBranch.id);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/get-provider-profile', httpOptions);
  }

  //Edit Provider & Hopsital Details
  editProviderBranchProfile(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/providerGroup/edit-provider-branch-profiles', data, httpOptions);
  }

  getAllCertificateName() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/getAllCertificateName', httpOptions);
  }

  addProviderQualityCertificate(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/providerGroup/add-provider-quality-certificate', data, httpOptions);
  }

  getProviderQualityCertificate() {
    const param = new HttpParams().set('providerBranchProfileId', this.authService.currentUserValue.providerBranchProfile.id);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/getActiveProviderQualityCertificate', httpOptions);
  }

  deleteProviderQualityCertificate(id: any) {
    const param = new HttpParams().set('proQualCertId', id)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.delete(environment.apiBaseUrl + '/trueclaim/providerGroup/delete-quality-certificate', httpOptions);
  }


  //Services  API's

  getAllRoomTypes() {
    const param = new HttpParams().set('providerBranchId', this.authService.currentUserValue.providerBranch.id)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/getAllRoomType', httpOptions);
  }

  getLineOfTreatment() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/getLineOfTreatment', httpOptions);
  }

  //Get all Service Details
  getAllProviderServices() {
    const param = new HttpParams().set('id', this.authService.currentUserValue.providerBranchProfile.id)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/get-provider-all-services', httpOptions);
  }

  //Edit Service Details
  editProviderServiceProfile(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/providerGroup/edit-provider-services', data, httpOptions);
  }

  //Get the Services list
  getServicesList() {
    const param = new HttpParams()
      .set('proBranchProfId', this.authService.currentUserValue.providerBranchProfile.id)
      .set('type', 'SERVICE')
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/get-provider-service-speciality', httpOptions);
  }
  //Edit Services
  editProviderServices(servicesList: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/providerGroup/edit-provider-service-master-mapping', servicesList, httpOptions);
  }

  //Get the Specialities list
  getSpecialitiesList() {
    const param = new HttpParams()
      .set('proBranchProfId', this.authService.currentUserValue.providerBranchProfile.id)
      .set('type', 'SPECIALITY')
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/get-provider-service-speciality', httpOptions);
  }
  //Edit Specialities
  editProviderSpecialities(specialitiesList: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/providerGroup/edit-provider-speciality-master-mapping', specialitiesList, httpOptions);
  }



  //Contact Info API's 
  //GetDesignation
  getProviderContactType() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/getAllProviderContactType', httpOptions);
  }

  //getContacts
  getProviderBranchContact(designation: any) {
    let param: any;

    if (designation === '') {
      param = new HttpParams()
        .set('proBranchProfId', this.authService.currentUserValue.providerBranchProfile.id);
    } else {
      param = new HttpParams()
        .set('proBranchProfId', this.authService.currentUserValue.providerBranchProfile.id)
        .set('designationType', designation);
    }
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerGroup/getAllProviderBranchProfileContacts', httpOptions);
  }

  //Add Contact
  addProviderGroupContact(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/providerGroup/add-provider-branch-profile-contacts', data, httpOptions);
  }

  //Edit Contact
  editProviderGroupContact(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/providerGroup/edit-provider-branch-profile-contacts', data, httpOptions);
  }

  //Delete Contact
  deleteProviderGroupContact(id: any) {
    const param = new HttpParams().set('proBranchContId', id)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.delete(environment.apiBaseUrl + '/trueclaim/providerGroup/delete-provider-branch-contact', httpOptions);
  }

  fileupload = (data: any): Observable<any> => {
    const httpOptions = {
      // headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    
    return this.http.post(environment.apiBaseUrl  + '/trueclaim/edit/provider-file-upload', data, httpOptions);
  }
  editProviderData(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/edit/edit-provider-data', data, httpOptions);
  }
  
  // Add Document
  getAllDocumentType(){
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerBranch/getAllProviderDocumentType', httpOptions);
  }

  getAllProviderDocument(id:any) {
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const param = new HttpParams().set('providerBranchProfileId', id);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerBranch/getAllProviderDocumentUploadByProviderBranchProfileId', httpOptions);
  }

  addProviderDocument(data:any){
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/providerBranch/add-edit-provider-documents', data, httpOptions);
  }

  deleteProviderDocument(id:any){
    const param = new HttpParams().set('id', id)
    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerBranch/deleteProviderDocumentUploadById', httpOptions);
  }
  
  getUpdateProviderLogs(id:any,page: number, pageSize: number){

    let token = null;
    if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    if (localStorage.getItem('admin_tc_token')) {
      token = localStorage.getItem('admin_tc_token');
    }
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Token ' + token,
      }),
      params: {
        providerBranchId:id,
        page: page.toString(),
        size: pageSize.toString()
      }
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/edit/fetch-logs-of-approval-for-provider', httpOptions);
  }
  
  getTotalLogsCount(id:any,page: number, pageSize: number){
    let token: any = null;
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    } else if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
  
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Token ' + token
      }),
      params: {
        providerBranchId:id,
        page: page.toString(),
        size: pageSize.toString()
      }
    };
  
    return this.http.get(environment.apiBaseUrl+ '/trueclaim/edit/fetch-count-logs-of-approval-for-provider', httpOptions);
  }
  
  getAllProviderPhotos(id: any){
    const params = new HttpParams().set('id',id)
    let token: any = null;
    if (localStorage.getItem('hospital_tc_token')) {
      token = localStorage.getItem('hospital_tc_token');
    } else if (localStorage.getItem('tpa_tc_token')) {
      token = localStorage.getItem('tpa_tc_token');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Token ' + token
      }),
      params: params 
    };
    return this.http.get( environment.apiBaseUrl+'/trueclaim/get-hospital-photos?', httpOptions) 
   }
}
